import { get } from '@eika-infrastruktur/request';

import { REST_BASE_URL_DEBIT_CARDS } from '@/react-query/common';

import { CardType, DebitCardOrderResponse, DeprecatedCardOrderRequest } from '@generated-types';
import { cardTypePost } from '@utils/query-utils';

interface RequestHeaders {
    headers: {
        [k: string]: string;
    };
}

const getRequestHeaders = (): RequestHeaders => ({
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-By': 'kredittkort-js-client',
    },
});
export const orderDebitCard = async (accountNumber: string, changePin = false, manual = false) => {
    const request: DeprecatedCardOrderRequest = {
        accountNumber,
        changePin,
    };

    return cardTypePost(CardType.DEBIT)<DebitCardOrderResponse | null>(
        `${REST_BASE_URL_DEBIT_CARDS}`,
        request,
        new URLSearchParams([['manual', `${manual}`]]),
    );
};

export const getDebitCardSigningOrder = (accountNumber: string): Promise<DebitCardOrderResponse> => {
    const url = `${REST_BASE_URL_DEBIT_CARDS}/${accountNumber}/order`;
    return get(url, getRequestHeaders());
};
